import { BasicFacetTermV2, BasicFacetWithTermsV2 } from '@ravago/shared/page-data/models/elastic';

import { firstBy } from 'thenby';

import { FacetContentV2 } from '../models/facet-group.model';

export const COLLECTION_FACET_SORT_ORDER = firstBy(
   (facetGroupContent: FacetContentV2) => facetGroupContent.count > 0 || facetGroupContent.count === -1,
   'desc'
).thenBy('label', 'asc');

export const FACET_SORT_ORDER = (activeFacet: BasicFacetWithTermsV2 | undefined, activeNestedFacet: BasicFacetWithTermsV2 | undefined) =>
   firstBy((facetGroupContent: FacetContentV2) => facetGroupContent.count > 0 || facetGroupContent.count === -1, 'desc')
      .thenBy((facetGroupContent: FacetContentV2) => {
         if (!activeFacet && !activeNestedFacet) return false;
         return (
            (!!activeFacet && activeFacet.terms.some((t) => t.key === facetGroupContent.key)) ||
            (!!activeNestedFacet && activeNestedFacet.terms.some((t) => t.parentKey === facetGroupContent.key))
         );
      }, 'desc')
      .thenBy('label', 'asc');

export const RANGE_FACET_SORT_ORDER = (activeFacet: BasicFacetWithTermsV2 | undefined, activeNestedFacet: BasicFacetWithTermsV2 | undefined) =>
   firstBy((facetGroupContent: FacetContentV2) => {
      if (!activeFacet && !activeNestedFacet) return false;
      return (
         (!!activeFacet && activeFacet.terms.some((t) => t.key === facetGroupContent.key)) ||
         (!!activeNestedFacet && activeNestedFacet.terms.some((t) => t.parentKey === facetGroupContent.key))
      );
   }, 'desc')
      .thenBy((facetGroupContent: FacetContentV2) => facetGroupContent.count > 0 || facetGroupContent.count === -1, 'desc')
      .thenBy('label', 'asc');

export const doesFacetContainSearchValue = (searchValue: string, facetContent: FacetContentV2): boolean =>
   facetContent.label.toLowerCase().includes(searchValue.toLowerCase()) ||
   (facetContent.nestedFacetGroups?.some((nestedFacet) =>
      nestedFacet.facets.some((nestedFacetContent) => doesFacetContainSearchValue(searchValue, nestedFacetContent))
   ) ??
      false);

export const mergeNestedTerms = (changedFacets: Array<BasicFacetTermV2>, parentKey: string, existingFacets: Array<BasicFacetTermV2> = []) => {
   const otherParentNestedTerms = existingFacets.filter((facet) => facet.parentKey !== parentKey);
   return [...otherParentNestedTerms, ...changedFacets];
};
